import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';

export class PerformanceMaxImportDescriptionColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, newI18n }) {
    const title = newI18n.getString(_TL_('What we\'ll do'));
    super({
      name: 'performanceMaxImportDescription',
      property: 'PerformanceMaxImportDescription',
      title,
      bodyClasses: ['grid-column-performance-max-import-description'],
      colClasses: ['col-superLongText'],
      type: 'string',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
    this.newI18n = newI18n;
  }

  template() {
    return this.newI18n.getString(_TL_('We\'ll set up a one-time import using default settings to pull all campaigns from your most recently imported Google Ads account, including your Performance Max campaigns. This import will run 24 hours after you select <b>Create import</b>.  We\'ll notify you once the import is ready for your review.'));
  }
}
